import { render, staticRenderFns } from "./LeadBoardDealDetails.vue?vue&type=template&id=7da8ab1c&"
import script from "./LeadBoardDealDetails.vue?vue&type=script&lang=js&"
export * from "./LeadBoardDealDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports